import { AssetCustomFieldValuesApi } from '@evimo/client/apis';
import { createApiConfiguration } from '~/app/lib/api-config';

const config = createApiConfiguration();

export const assetCustomFieldValuesApi = new AssetCustomFieldValuesApi(config);

export const assetCustomFieldValueRequestInit = {
  credentials: 'include' as const,
};
